module.exports = __webpack_public_path__ + "img/icon5.ee2b2c18.png";